
// export const formatDateTime = (dateTime) => {
//     const date = new Date(dateTime);
//     return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
// };

export const formatDateTime = (dateTime) => {
    if (!dateTime) return "";
    const date = new Date(dateTime);
    if (isNaN(date.getTime())) return "";
    const options = {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    };
    return date.toLocaleDateString('en-GB', options);
};